<div #container *ngIf="text" class="m-0 js-container-toggle-text container-toggle-text">
  <span class="first-part"> {{ getPartOfString(text, 1) }}<span *ngIf="hasSecondPart(text)" class="ellipse">...</span> </span>

  <span
    *ngIf="hasSecondPart(text)"
    class="show-more"
    (click)="toggleText()"
    (keyup.enter)="toggleText()"
    (keyup.space)="toggleText()"
    [attr.tabindex]="0"
  >
    {{ 'toggleText.showMore' | cxTranslate }}</span
  >

  <span *ngIf="hasSecondPart(text)" class="last-part">
    {{ getPartOfString(text, 2) }}
  </span>

  <span
    *ngIf="hasSecondPart(text)"
    class="show-less"
    (click)="toggleText()"
    (keyup.enter)="toggleText()"
    (keyup.space)="toggleText()"
    [attr.tabindex]="0"
  >
    {{ 'toggleText.showLess' | cxTranslate }}</span
  >
</div>
